import { ReactNode, useState } from "react";
import PlusIcon from "../../icons/plus.icon";
import MinusIcon from "../../icons/minus.icon";

export default function Accordion({ title, children }: { title: ReactNode; children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  if (isOpen) {
    return (
      <div className="border rounded-lg mb-2 overflow-visible">
        <button
          data-role="collapse"
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          className="w-full flex justify-between items-center p-4 bg-gray-100 hover:bg-gray-200 dark:bg-her-darkSectionBg rounded-t-lg"
        >
          <span className="text-left font-medium">{title}</span>
          <MinusIcon className="w-6 h-6 text-her-mysticMaroon" />
        </button>
        {isOpen && (
          <div className="border-t bg-white dark:bg-her-darkSectionBg overflow-visible last:rounded-b-lg">{children}</div>
        )}
      </div>
    );
  }

  return (
    <div className="border rounded-lg mb-2 overflow-visible">
      <button
        data-role="expand"
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex justify-between items-center p-4 bg-gray-100 hover:bg-gray-200 dark:bg-her-darkSectionBg rounded-lg"
      >
        <span className="text-left font-medium">{title}</span>
        <PlusIcon className="w-6 h-6 text-her-blue" />
      </button>
      {isOpen && <div className="border-t bg-white dark:bg-her-darkSectionBg overflow-visible last:rounded-b-lg">{children}</div>}
    </div>
  );
}
